import React from 'react';
import type { BombiixIconProps } from './types';

/** Bombiix Approve icon. Exported from Figma (Bombiix 2026). */
const ApproveIcon: React.FC<BombiixIconProps> = ({ size = 20, ...rest }) => (
  <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" {...rest}>
    <rect width="20" height="20" rx="4" fill="#D8D8D8" />
    <g>
      <path
        d="M16.166 10.001C16.166 6.61056 13.3904 3.83416 10 3.83398C6.60948 3.83398 3.83301 6.61045 3.83301 10.001C3.83319 13.3914 6.60958 16.167 10 16.167C13.3903 16.1668 16.1658 13.3912 16.166 10.001ZM17.166 10.001C17.1658 13.9435 13.9426 17.1668 10 17.167C6.0573 17.167 2.83319 13.9436 2.83301 10.001C2.83301 6.05817 6.05719 2.83398 10 2.83398C13.9427 2.83416 17.166 6.05828 17.166 10.001Z"
        fill="#A4A4A4"
      />
      <path
        d="M12.4804 7.75965C12.6758 7.56461 12.9923 7.56437 13.1874 7.75965C13.3825 7.95509 13.3819 8.27159 13.1865 8.46668L9.40718 12.2401C9.21189 12.4351 8.89529 12.4352 8.70014 12.2401L6.81343 10.3534C6.61817 10.1581 6.61819 9.84164 6.81343 9.64637C7.00869 9.45111 7.32519 9.45111 7.52046 9.64637L9.05366 11.1796L12.4804 7.75965Z"
        fill="#A4A4A4"
      />
    </g>
  </svg>
);

export default ApproveIcon;
